export default "__VITE_ASSET__B9bR$cHg__"